const PROJECT_CATEGORIES = [
  "Transportation & Mobility",
  "AI Assistants & Language Tools",
  "Enterprise AI & Automation",
  "Full-Stack Platforms & Tools",
  "Recruiting & Workforce",
  "Healthcare AI",
  "Real Estate Analytics",
  "Recommendation Systems",
  "Predictive Analytics",
  "Energy & EV Analytics",
  "Computer Vision & Robotics",
];

export default PROJECT_CATEGORIES;
